<template lang="pug">
    r-form(
        ref='form'
        submit-text='guardar'
        title='crear nota de debito'
        v-bind='formProps'
        v-model='formData'
        @reset='reset'
        @submit='submit'
    )
</template>

<script>
    //
    import { mapActions, mapState } from 'vuex'
    import { ModelAutocomplete, RForm } from '@/components/reusable_components/next'
    //
    import PurchaseDebitNoteModel from '@/models/Purchase/PchPurchaseDebitNote'
    import PurchaseDebitNoteFields from '@/views/Purchase/PchPurchaseDebitNote/PchPurchaseDebitNoteFields'
    //
    import TranslatorService from '@/services/translator'
    //
    export default {
        name: 'purchase-debit-note-create',
        components: {
            RForm,
        },
        computed: {

            /**
             * { item_description }
             */
            ...mapState('SnackbarModalModule', ['responseConfirm']),

            /**
             * { function_description }
             *
             * @return     {Object}  { description_of_the_return_value }
             */
            fieldsProps() {
                return {
                    document_type_title: this.fieldsVariant ? 'Documento: Nota de debito' : 'Documento: Factura de compra',
                    pch_provider_branch_offices: this.formData.pch_provider_branch_offices,
                    pch_provider_trigger: this.triggerProvider,
                }
            },

            /**
             * { function_description }
             *
             * @return     {<type>}  { description_of_the_return_value }
             */
            fieldsVariant() {
                return this.formData.document_type
            },

            /**
             * { function_description }
             *
             * @return     {Object}  { description_of_the_return_value }
             */
            formProps() {
                return {
                    fields: PurchaseDebitNoteFields(this.fieldsProps).variant(this.fieldsVariant),
                }
            }
        },
        data() {
            return {
                formData: new PurchaseDebitNoteModel({
                    document_type: 0,
                    extra_tax: 0,
                    pch_provider_branch_offices: [],
                    new_subtotal: 0,
                    iva: 1,
                    total: 0,
                }),
            }
        },
        methods: {

            /**
             * { item_description }
             */
            ...mapActions('MenuesModule', ['setTitleTopBar']),

            /**
             * { item_description }
             */
            ...mapActions('SnackbarModalModule', [
                'setErrorSnackbar',
                'setSuccessSnackbar',
                'setWarningSnackbar',
            ]),

            /**
             * { function_description }
             *
             * @param      {<type>}  error   The error
             */
            error(error) {
                this.setErrorSnackbar(TranslatorService(PurchaseDebitNoteModel, error.response.data))
            },

            /**
             * { function_description }
             */
            redirect() {
                this.$router.push({ name: 'purchase-debit-note-list' })
            },

            /**
             * { function_description }
             *
             * @return     {<type>}  { description_of_the_return_value }
             */
            submit() {
                return this.fieldsVariant ? this.submitCancel() : this.submitCreate()
            },

            /**
             * { function_description }
             *
             * @return     {<type>}  { description_of_the_return_value }
             */
            submitCancel() {
                return this.toWait().then(this.toCancel).then(this.toWait)
            },

            /**
             * { function_description }
             *
             * @return     {<type>}  { description_of_the_return_value }
             */
            submitCreate() {
                return this.toWait().then(this.toCreate).then(this.toWait)
            },

            /**
             * { function_description }
             *
             * @return     {<type>}  { description_of_the_return_value }
             */
            success() {
                return this.setSuccessSnackbar('Nota de debito agregada exitosamente.')
            },

            /**
             * { function_description }
             *
             * @param      {<type>}  model   The model
             * @return     {<type>}  { description_of_the_return_value }
             */
            toCancel(model) {
                return model
                    .cancelPurchaseCreditNote()
                    .attach(model.toCancelPurchaseCreditNote())
                    .then(this.success)
                    .then(this.redirect)
                    .catch(this.error)
            },

            /**
             * { function_description }
             *
             * @param      {<type>}  model   The model
             * @return     {<type>}  { description_of_the_return_value }
             */
            toCreate(model) {
                return model
                    .toCreate()
                    .save()
                    .then(this.success)
                    .then(this.redirect)
                    .catch(this.error)
            },

            /**
             * { function_description }
             *
             * @param      {boolean}  [value=false]  The value
             * @return     {<type>}   { description_of_the_return_value }
             */
            toWait(value = false) {
                return this.$refs.form.setWait(value)
            },

            /**
             * { function_description }
             *
             * @param      {<type>}  ctx     The context
             */
            triggerProvider(ctx) {
                this.formData.pch_provider_branch_offices = ctx
                    .getInput('pch_provider_id')
                    .getSelected()
                    .getProperty('branch_offices', [])
            }
        },
        mounted() {
            this.setTitleTopBar('Crear nota de debito')
        },
    }
</script>